angular.module('impactx.invoice').controller('CustomInvoiceViewCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$routeParams',
    'TranslationService',
    'ToolbarService',
    'DownloadService',
    '$window',
    '$mdDialog',
    '$route',
    'InvoiceDialogService',
    'ConfirmationService',
    '$timeout',
    '$context',
    '$redirect',
    CustomInvoiceViewCtrl
]);

function CustomInvoiceViewCtrl($scope, dataGen, BackService, ToastService, $routeParams, TranslationService, ToolbarService,
                               DownloadService, $window, $mdDialog, $route, InvoiceDialogService, ConfirmationService, $timeout,
                               $context, $redirect) {
    var ctrl = this;
    var blhId = $routeParams.id;
    $scope.blhId = blhId;

    var atiId = $routeParams.atiId || 0;

    $scope.showHistory = false;
    $scope.showExported = false;
    $scope.showComplaints = true;
    ctrl.itemComplaint = undefined;
    $scope.showComments = true;

    $scope.itemSelection = [];
    $scope.allSelected = false;

    $scope.isSingleItemSelection = function () {
        return $scope.itemSelection.length === 1;
    }
    $scope.hasItemSelection = function () {
        return $scope.itemSelection.length > 0;
    }

    var approvalActionData = {
        BLH_Id: blhId,
        type: "blh",
        id: atiId
    };

    ctrl.getData = function () {
        var paramObj = {
            blhId: blhId
        };
        if (atiId) {
            paramObj.atiId = atiId;
            dataGen.getData($scope, paramObj, '/approval/invoicecustom').then(function () {
                defineButtons();
                defineScollList();
                defineTimeouts();
            });
        }
        else {
            dataGen.getData($scope, paramObj, '/invoice/viewcustomdialog').then(function () {
                defineButtons();
                defineScollList();
                defineTimeouts();
            });
        }
        $scope.itemSelection = [];
    };

    ctrl.selectAllItems = function () {
        $scope.allSelected = !$scope.allSelected;
        if($scope.allSelected)
        {
            $scope.itemSelection = [];
            if ($scope.data.deliveryItems) {
                for (var i = 0; i < $scope.data.deliveryItems.length; i++) {
                    var deliveryItem = $scope.data.deliveryItems[i];
                    deliveryItem.selected = false;
                    ctrl.selectDeliveryItem(deliveryItem);
                }
            }
            if ($scope.data.additionalItems) {
                for (var j = 0; j < $scope.data.additionalItems.length; j++) {
                    var additionalItem = $scope.data.additionalItems[j];
                    additionalItem.selected = false;
                    ctrl.selectComplaintItem(additionalItem);
                }
            }
        } else
        {
            $scope.itemSelection.forEach((selection)=> selection.item.selected = false);
            $scope.itemSelection = [];
        }
    };

    ctrl.selectComplaintItem = function (item) {
        selectItem(item, 'PDNE');
    };

    ctrl.selectDeliveryItem = function (item) {
        selectItem(item, 'DNI');
    };

    ctrl.toggleItem = function(event, item) {
        item.isExpanded = !item.isExpanded;
        event.stopPropagation();
    };

    ctrl.unmatchDeliveryNote = function (event, dnhId) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {blhId: blhId, dnhIds: [dnhId]}, '/invoice/unmatch/deliverynote').then(function () {
                ctrl.getData();
                ToastService.openStandardToast($scope.trns.unmatchMessage);
            });
        }, event, $scope.trns.unmatchQuestion, TranslationService.get('ok'), TranslationService.get('abort'));
    };

    ctrl.getArchivedFile = function () {
        DownloadService.openDownloadPost('/invoice/archive/download', {paramName: "archiveNo", paramValue: $scope.data.archiveNumber.value})
    };

    ctrl.getColorClassForDifference = function(diff) {
        if(!diff) {
            return  ''
        }
        let i = 0
        if(diff.charAt(diff.length - 1) === "%") {
            i = parseInt(diff.slice(0,-1))
        } else {
            i = parseInt(diff)
        }

        if(i > 0) {
            return 'invoice-sum-red'
        }
        if(i < 0) {
            return 'invoice-sum-green'
        }
        return ''
    };

    ctrl.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    ctrl.toggleExported = function () {
        $scope.showExported = !$scope.showExported;
    }

    ctrl.toggleComplaints = function () {
        $scope.showComplaints = !$scope.showComplaints;
    }

    ctrl.toggleHistory = function () {
        $scope.showHistory = !$scope.showHistory;
    }

    ctrl.toggleComments = function () {
        $scope.showComments = !$scope.showComments;
    }

    this.deactivate = function (event) {
        InvoiceDialogService.deactivate(event, $scope.data.id, $scope.trns.deactivateMessage, $scope.trns.saveSuccess);
    };

    this.reactivate = function (event) {
        InvoiceDialogService.reactivate(event, $scope.data.id, $scope.trns.reactivateMessage, $scope.trns.saveSuccess);
    };

    this.deactivateItems = function (event) {
        InvoiceDialogService.deactivateItems(event, $scope.data.id, $scope.itemSelection, $scope.trns.deactivateItemsMessage, $scope.trns.saveSuccess, ctrl.getData);
    };

    this.reactivateItems = function (event) {
        InvoiceDialogService.reactivateItems(event, $scope.data.id, $scope.itemSelection, $scope.trns.reactivateItemsMessage, $scope.trns.saveSuccess, ctrl.getData);
    };

    this.completeComplaint = function (event) {
        InvoiceDialogService.showCompleteComplaintDialog(event, $scope.data.id).then(function () {
            ctrl.getData();
        });
    }

    this.headerComplaint = function (event) {
        InvoiceDialogService.showHeaderComplaintDialog(event, $scope.data.id).then(function () {
            ctrl.getData();
        });
    }

    this.itemComplaint = function (event) {
        InvoiceDialogService.showItemComplaintDialog(event, $scope.data.id, $scope.itemSelection[0].id, $scope.itemSelection[0].type, $scope.itemSelection[0].item).then(function () {
            ctrl.getData();
        });
    }

    this.deleteComplaints = function (event) {
        InvoiceDialogService.showComplaintDelete(event, $scope.data.id, $scope.trns.deleteComplaintsMessage, $scope.trns.saveSuccess).then(function () {
            ctrl.getData();
        });
    };

    ctrl.copyItem = function (event) {
        InvoiceDialogService.showCorrectionNewItemDialogCopy(event, $scope.data.id, $scope.itemSelection[0].id, $scope.itemSelection[0].type).then(function () {
            ctrl.getData();
        });
    };

    ctrl.addItem = function (event) {
        InvoiceDialogService.showCorrectionNewItemDialog(event, $scope.data.id, 0).then(function () {
            ctrl.getData();
        });
    };

    ctrl.editAddedItem = function (event) {
        InvoiceDialogService.showCorrectionNewItemDialog(event, $scope.data.id, $scope.itemSelection[0].id).then(function () {
            ctrl.getData();
        });
    };

    ctrl.correctItem = function (event) {
        InvoiceDialogService.showCorrectionEditItemDialog(event, $scope.data.id, $scope.itemSelection[0].id, $scope.itemSelection[0].item).then(function () {
            ctrl.getData();
        });
    };

    ctrl.editItems = function (event) {
        InvoiceDialogService.showEditItemsDialog(event, $scope.data.id, $scope.itemSelection).then(function () {
            ctrl.getData();
        });
    };

    ctrl.deleteCorrectionItem = function (item, type) {
        dataGen.postAsForm({}, {blhId: $scope.data.id, id: item.id, type: type}, '/invoice/complaint/correction/item/delete').then(function () {
            ctrl.getData();
        });
    };

    ctrl.deleteComplaintItem = function (event, iciId) {
        InvoiceDialogService.showComplaintItemDelete(event, iciId, $scope.trns.deleteComplaintItemMessage).then(function () {
            ctrl.getData();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    }

    ctrl.signalAlive = function () {
        if(!$scope.signalAliveCalled) {
            $scope.signalAliveCalled = true;
            dataGen.getData({}, {blhId: blhId}, '/invoice/viewcustomdialog/signalalive');
            $scope.timeoutMillis = setTimeout(() => {
                $scope.signalAliveCalled = false;
            }, 15000);

            if($scope.timeout) {
                clearTimeout($scope.timeout);
            }
            $scope.timeout = setTimeout(() => {
                const count = document.querySelectorAll('md-dialog').length;
                for (let i = 0; i < count; ++i) {
                    $mdDialog.cancel();
                }
                $redirect.redirectTo(null, "/custominvoiceoverview");
            }, $scope.data.timeoutMillis);
        }
    }

    ctrl.handleInterval = function () {
        dataGen.getData({}, {blhId: blhId, lastChange: $scope.data.lastChangeDate},
            '/invoice/viewcustomdialog/state').then(function (data) {
            if (data.data) {
                $scope.data = data.data;
                if (ctrl.isCurrentUser()) {
                    clearInterval($scope.updateIntervalMillis);
                    defineButtons();
                    defineTimeouts();
                }
            }
        });
    }

    function defineTimeouts() {
        $window.removeEventListener("mousemove", ctrl.signalAlive);
        if($scope.data.timeoutMillis > 0 && ctrl.isCurrentUser()) {
            $scope.signalAliveCalled = false;
            $window.addEventListener("mousemove", ctrl.signalAlive);
        }

        if($scope.updateIntervalMillis) {
            clearInterval($scope.updateIntervalMillis);
        }
        if($scope.data.updateIntervalMillis > 0 && !ctrl.isCurrentUser()) {
            $scope.updateIntervalMillis = setInterval(ctrl.handleInterval, $scope.data.updateIntervalMillis);
        }
    }

    ctrl.isCurrentUser = function () {
        return $context.userId.value === $scope.data.currentEditUserId;
    }

    function defineButtons() {
        var buttonDefinition = [];
        if(!ctrl.isCurrentUser()) {
            // No action buttons for non-current user
        }
        else if (atiId) {
            buttonDefinition = [
                {
                    label: $scope.trns.approveAll,
                    action: approveAll,
                    type: 'dialogAction',
                    condition: canApproveAll
                },
                {
                    label: $scope.trns.denyAll,
                    action: denyAll,
                    type: 'dialogAction',
                    condition: canDenyAll
                },
                {
                    label: $scope.trns.delegateAll,
                    action: delegateAll,
                    type: 'dialogAction',
                    condition: canDelegateAll
                }
            ];
        }
        else
        {
            buttonDefinition = [
                {
                    label: $scope.trns.deactivate,
                    action: ctrl.deactivate,
                    type: 'dialogaction',
                    condition: canDeactivate
                },
                {
                    label: $scope.trns.reactivate,
                    action: ctrl.reactivate,
                    type: 'dialogaction',
                    condition: canReactivate
                },
                {
                    label: $scope.trns.deactivate,
                    action: ctrl.deactivateItems,
                    type: 'dialogaction',
                    condition: canDeactivatePositions
                },
                {
                    label: $scope.trns.reactivate,
                    action: ctrl.reactivateItems,
                    type: 'dialogaction',
                    condition: canActivatePositions
                },
                {
                    label: $scope.trns.closeInvoice,
                    action: closeInvoice,
                    type: 'dialogAction',
                    condition: canClose
                },
                {
                    label: $scope.trns.match,
                    linkFunction: getMatchLink,
                    type: 'link',
                    condition: canMatch,
                },
                {
                    label: $scope.trns.newItem,
                    action: ctrl.addItem,
                    type: "dialogAction",
                    condition: canAddItem
                },
                {
                    label: $scope.trns.copyItem,
                    action: ctrl.copyItem,
                    type: "dialogAction",
                    condition: canCopyItem
                },
                {
                    label: $scope.trns.edit,
                    action: ctrl.editAddedItem,
                    type: "dialogAction",
                    condition: canEditAddedItem
                },
                {
                    label: $scope.trns.correctItem,
                    action: ctrl.correctItem,
                    type: "dialogAction",
                    condition: canCorrectItem
                },
                {
                    label: $scope.trns.editItems,
                    action: ctrl.editItems,
                    type: "dialogAction",
                    condition: canEditItems
                },
                {
                    label: $scope.trns.completeComplaints,
                    action: ctrl.completeComplaint,
                    type: 'dialogaction',
                    condition: canCompleteComplaint
                },
                {
                    label: $scope.trns.headerComplaints,
                    action: ctrl.headerComplaint,
                    type: 'dialogaction',
                    condition: canHeaderComplaint
                },
                {
                    label: $scope.trns.itemComplaint,
                    action: ctrl.itemComplaint,
                    type: 'dialogaction',
                    condition: canItemComplaint
                },
                {
                    label: $scope.trns.deleteComplaints,
                    action: ctrl.deleteComplaints,
                    type: 'dialogaction',
                    condition: canDeleteComplaints
                },
                {
                    label: $scope.trns.percentageDistribution,
                    action: distributeComplaint,
                    type: 'dialogaction',
                    condition: canDistributeComplaint
                },
                {
                    label: $scope.trns.deletePercentageDistribution,
                    action: ctrl.deleteDistributeComplaintDialog,
                    type: 'dialogaction',
                    condition: canDeleteDistributeComplaint
                },
                {
                    label: $scope.trns.resetPositions,
                    action: ctrl.resetPositionsDialog,
                    type: 'dialogaction',
                    condition: canResetPositions
                },
                {
                    label: $scope.trns.resetInvoice,
                    action: ctrl.resetInvoiceDialog,
                    type: 'dialogaction',
                    condition: canResetInvoice
                }
            ];
        }
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDeactivate() {
        return $scope.data.canDeactivate && !$scope.hasItemSelection();
    }

    function canReactivate() {
        return $scope.data.canReactivate && !$scope.hasItemSelection();
    }

    function canCopyItem() {
        return $scope.isSingleItemSelection() && $scope.data.canUseItemCorrection &&
            ($scope.itemSelection[0].type === 'PDNE' || $scope.itemSelection[0].type === 'DNI');
    }

    function canAddItem() {
        return !$scope.hasItemSelection() && $scope.data.canUseItemCorrection;
    }

    function canEditAddedItem() {
        return $scope.isSingleItemSelection() && $scope.itemSelection[0].type === 'PDNE' && $scope.data.canUseItemCorrection;
    }

    function canCorrectItem() {
        return $scope.isSingleItemSelection() && $scope.itemSelection[0].type === 'DNI' && $scope.data.canUseItemCorrection
    }

    function canEditItems() {
        return $scope.hasItemSelection() && !$scope.isSingleItemSelection() && $scope.data.canUseItemCorrection
    }

    function canCompleteComplaint() {
        return $scope.data.canCompleteComplaint;
    }

    function canHeaderComplaint() {
        return $scope.data.canHeaderComplaint;
    }

    function canItemComplaint() {
        return $scope.data.canItemComplaint && $scope.isSingleItemSelection();
    }

    ctrl.canDeleteHeaderComplaint = function (){
        return $scope.data.canDeleteHeaderComplaint && ctrl.isCurrentUser();
    }

    ctrl.canDeleteItemComplaint = function (){
        return $scope.data.canDeleteItemComplaint && ctrl.isCurrentUser();
    }

    function canDeleteComplaints() {
        return $scope.data.canDeleteCompleteComplaint && ctrl.isCurrentUser();
    }

    function canDistributeComplaint() {
        return $scope.data.canDistributeComplaint;
    }

    function canDeleteDistributeComplaint() {
        return $scope.data.canDeleteDistributeComplaint;
    }

    var approveAll = function () {
        return dataGen.postAsForm($scope, {items: [approvalActionData]}, "/approval/approve/all").then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    var denyAll = function (event) {
        return showApprovalStopOrDenyDialog(event, $scope.trns.approvalComment, $scope.trns.denyAll).then(function (answer) {
            approvalActionData.newComment = answer;
            dataGen.postAsForm($scope, {items: [approvalActionData]}, "/approval/deny/all").then(function () {
                $route.reload();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            });
        });
    };

    var delegateAll = function(ev) {
        return $mdDialog.show({
            controller: 'DelegationUserController',
            templateUrl: 'modules/approval/templates/delegationuser.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                selectionData: approvalActionData,
                entryPoint: "/approval/delegationuser"
            }
        }).then(function (answer) {
            if (answer !== false) {
                approvalActionData.delegationUserId = answer.id;
                dataGen.post($scope, approvalActionData, "/approval/delegate").then(function () {
                    $route.reload();
                    ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                });
            }
        });
    };

    var showApprovalStopOrDenyDialog = function (event, title, saveLabel) {
        return $mdDialog.show({
            controller: "ApprovalDenyOrStopCommentController",
            controllerAs: "approvalDenyOrStopCommentController",
            templateUrl: "modules/approval/templates/approval-deny-or-stop-comment.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                title: title,
                saveLabel: saveLabel
            }
        })
    };

    var closeInvoice = function (event) {
        return $mdDialog.show({
            controller: "CloseInvoiceVerificationCtrl",
            controllerAs: "closeInvoiceVerificationCtrl",
            templateUrl: "modules/invoice/templates/close-invoiceverification.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                blhId: blhId
            }
        }).then(function (answer) {
            if (answer) {
                // no save needed as of now.
                dataGen.postAsForm({}, {data: answer}, '/invoice/verification/close').then(function () {
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                    BackService.back();
                });
            }
        });
    };

    var distributeComplaint = function (event) {
        $mdDialog.show({
            controller: "PercentageDistributionCtrl",
            controllerAs: "percentageDistributionCtrl",
            templateUrl: "modules/invoice/templates/percentage-distribution.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                blhId: blhId
            }
        }).then(function () {
            ctrl.getData();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    this.deleteDistributeComplaintDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.deleteDistributeComplaint, event, $scope.trns.deletePercentageDistributionQuestion,
            TranslationService.get("delete"), TranslationService.get("abort"));
    };

    this.deleteDistributeComplaint = function () {
        dataGen.postAsForm({}, {id: blhId}, "/invoice/complaint/distribute/delete").then(function () {
            ctrl.getData();
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
        });
    };
    
    function canResetPositions() {
        return $scope.hasItemSelection() && $scope.itemSelection.some(function (item) {return item.canReset});
    }

    function canActivatePositions() {
        return $scope.hasItemSelection() && $scope.itemSelection.every(function (item) {return !item.item.isActive});
    }

    function canDeactivatePositions() {
        return $scope.hasItemSelection() && $scope.itemSelection.every(function (item) {return item.item.isActive});
    }

    this.resetPositionsDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.resetPositions, event, $scope.trns.resetPositionsQuestion,
            TranslationService.get("ok"), TranslationService.get("abort"));
    };

    this.resetPositions = function () {
        dataGen.postAsForm({}, {blhId: $scope.data.id, items: $scope.itemSelection}, '/invoice/complaint/correction/items/delete').then(function () {
            ctrl.getData();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    function canResetInvoice() {
        return !$scope.hasItemSelection() && $scope.data.canResetInvoice;
    }

    this.resetInvoiceDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.resetInvoice, event, $scope.trns.resetInvoice,
            TranslationService.get("ok"), TranslationService.get("abort"), $scope.trns.resetInvoiceQuestion);
    };

    this.resetInvoice = function () {
        dataGen.postAsForm({}, {blhId: $scope.data.id}, '/invoice/custom/reset').then(function () {
            ctrl.getData();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    function selectItem(item, type) {
        item.selected = !item.selected;
        if (item.selected) {
            $scope.itemSelection.push({
                id: item.id,
                type: type,
                item: item,
                canReset: item.canReset || (items.hasCorrectionItem && $scope.data.canUseItemCorrection) ||
                    (item.itemComplaints && item.itemComplaints.length > 0 && $scope.data.canDeleteItemComplaint) ||
                    (type === 'PDNE' && $scope.data.canUseItemCorrection)
            })
        }
        else
        {
            const index = $scope.itemSelection.findIndex((val) => (val.id === item.id && val.type == type));
            if(index >= 0)
            {
                $scope.itemSelection.splice(index, 1);
            }
        }
    }

    this.setLastEditUser = function () {
        dataGen.getData({}, {id: blhId}, "/invoice/lastuser/set");
    }

    function canApproveAll() {
        return atiId && $scope.data.approvalActionNeeded;
    }

    function canDenyAll() {
        return atiId && $scope.data.approvalActionNeeded;
    }

    function canDelegateAll() {
        return atiId && $scope.data.approvalActionNeeded;
    }

    function canClose() {
        return $scope.data.canCloseInvoiceVerification;
    }

    function resetEditUsers () {
        if (atiId) {
            dataGen.postAsForm({}, {blhId: blhId}, '/approval/resetblheditusers')
        }
        else {
            dataGen.postAsForm({}, {blhId: blhId}, '/invoice/reseteditusers')
        }
    }

    function getMatchLink () {
        return 'custominvoicematch/' + $scope.data.id;
    }

    function canMatch () {
        return $scope.data.canMatch;
    }

    function defineScollList () {
        if ($scope.data) {
            var scrollList = [];
            scrollList.push({id: 'header', label: $scope.trns.header});
            scrollList.push({id: 'addresses', label: $scope.trns.addresses});
            scrollList.push({id: 'timeline', label: $scope.trns.timeline});
            scrollList.push({id: 'sums', label: $scope.trns.sums});
            if ($scope.data.invoiceComments) {
                scrollList.push({id: 'invoiceComments', label: $scope.trns.invoiceComment});
            }
            scrollList.push({id: 'items', label: $scope.trns.items});
            if ($scope.data.exportedItems) {
                scrollList.push({id: 'exportedItems', label: $scope.trns.exportedItems});
            }
            if ($scope.data.completeComplaintDTOS || $scope.data.headerComplaintDTOS) {
                scrollList.push({id: 'invoiceComplaints', label: $scope.trns.complaintRecords});
            }
            if ($scope.data.approval) {
                scrollList.push({id: 'approvalStatus', label: $scope.trns.approvalProcess});
            }
            scrollList.push({id: 'history', label: $scope.trns.history});

            ToolbarService.setScrollMenu(scrollList);
        }
    }

    // onbeforeunload is not a perfect solution, because ist also gets called on reload (F5 etc.).
    // But it still kind of works here since on reload the data es retrieved from the backend again,
    // which also sets the edit user again. The only downside is that reload basically counts as
    // leaving and reopening the dialog.
    $window.onbeforeunload = resetEditUsers;
    $scope.$on('$destroy', function () {
        $window.removeEventListener("mousemove", ctrl.signalAlive);
        clearTimeout($scope.timeout);
        clearInterval($scope.updateIntervalMillis);
        resetEditUsers();
    });

    ctrl.getData();
}